export const isUnifiedTOCInDevMode = process.env.GATSBY_UNIFIED_TOC_DEV_MODE === 'true' ? true : false;
